module.exports = __webpack_public_path__ + "img/card_calendario_de_citas.232a1375.svg";